import type { Doubt } from "@/mocks/articles";

interface ArticleDoubtsProps {
  items: Doubt[];
}

export default function ArticleDoubts({ items }: ArticleDoubtsProps) {
  return (
    <div className="mt-6 space-y-4">
      {items.map((doubt, index) => (
        <div
          key={doubt.question}
          className="rounded-lg border border-primary-200 bg-primary-50/70 p-5 md:p-6"
        >
          <div className="flex items-start gap-3.5">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-500 font-heading text-xs font-black text-background-50">
              {index + 1}
            </span>
            <h4 className="pt-0.5 font-heading text-base font-bold text-foreground-950">
              {doubt.question}
            </h4>
          </div>
          <p className="mt-4 pl-0 text-sm leading-relaxed text-foreground-700 md:pl-[46px]">
            {doubt.analysis}
          </p>
        </div>
      ))}
    </div>
  );
}